import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { specsWidgetConfig, SpecsWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { SpecsWidgetContent } from "./components/SpecsWidgetContent"
import "./specs.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<SpecsWidgetConfig>) => {
    return {}
}

export default function SpecsWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<SpecsWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(specsWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="specs" data={data ?? {}}>
            <SpecsWidgetContent />
        </WidgetProvider>
    )
}
